export const SITE_STAGES = "SITE_STAGES";
export const SITE_ISSUES_LIST = "SITE_ISSUES_LIST";
export const SAVE_STAGES_DOCUMENTS = "SAVE_STAGES_DOCUMENTS";